import {Button} from "@seismic/mantle";
import React from "react";
import {useNavigate} from "react-router-dom";
import './Header.css';

export const Header = ({title, signOut, navigateTo, additionalContent }) => {
    
    const navigate = useNavigate();
    
    return <div style={{
        borderBottom: "1px solid #e2e2eb",
        backgroundColor: "white",
        height: "56px",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "8px"
    }}>
        <div style={{color: "#122A7E", display: "flex", justifyContent: "space-between", alignItems: "center",}}>
            <img height={16} width={16} src="/favicon.ico" alt="icon"/>
            <span onClick={() => navigate(navigateTo)}
                  style={{paddingLeft: "8px", fontSize: "24px", fontWeight: 800, color: "black"}}>
                    {title}
                </span>
        </div>
        <div className="navigation-items">
            <a href="/Web">Meetings</a>
            <a href="/ContentUsage">Content Usage</a>
            <a href="/Content">Content Usage Detail</a>
            <a href="/Pages">Slide Similarity</a>
            <a href="/VisualVersionHistory">Visual Version History</a>
            <a href="/Lineage">Slide Lineage</a>
            <a href="/Clusters">Clusters</a>
        </div>
        {additionalContent}
        <div>
            <Button label="Sign Out" onClick={signOut}/>
        </div>
    </div>
}